import { render, staticRenderFns } from "./RegionManagerList.vue?vue&type=template&id=282cf99a"
import script from "./RegionManagerList.vue?vue&type=script&lang=js"
export * from "./RegionManagerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports